<template>
  <div class="poster-box-vertical">
    <div class="thumb-box">
      <div class="picture-area" v-if="posterImage">
        <WebpImage
          :imageInfo="{
            imageUrl: posterImage,
            width: 240,
            height: 360,
            onImageLoad,
          }"
        />
      </div>
      <div v-else class="no-thumb" :aria-hidden="!isImageLoaded">
        <span class="alt-text">{{ posterAltText }}</span>
      </div>
    </div>
    <div class="picture-area">
      <WebpImage
        :imageInfo="{
          imageUrl: posterImage,
          width: 155,
          height: 87,
          option: 'b20',
          onImageLoad,
        }"
      />
    </div>
  </div>
</template>

<script>
  import WebpImage from '@/components/image/WebpImage'

  export default {
    name: 'PosterVertical',
    components: { WebpImage },
    props: {
      posterImage: {
        type: String,
        default: null,
      },
      posterAltText: {
        type: String,
        default: null,
      },
    },
    data() {
      return {
        isImageLoaded: false,
      }
    },
    watch: {
      posterImage() {
        this.isImageLoaded = false
      },
    },
    methods: {
      onImageLoad() {
        this.isImageLoaded = true
      },
    },
  }
</script>
<style lang="scss">
  @import '../../assets/scss/import/mixin';
  .poster-box-vertical {
    @include Position(absolute, $right: 0, $top: 0);
    width: 1240px;
    height: 698px;
    z-index: 10;
    .poster-thumb {
      width: 1240px;
      height: 698px;
    }
    &::before {
      @include Position(absolute, $left: 0, $top: 0);
      @include BackgroundImage(
        $path: '../../assets/images/vod/detail_gra_bg.png',
        $size: 1240px auto,
        $repeat: no-repeat
      );
      width: 1240px;
      height: 698px;
      z-index: 10;
      content: '';
    }
    &::after {
      @include Position(absolute, $left: 0, $right: 0, $top: 0);
      height: 1px;
      background-color: #1b1b1b;
      content: '';
    }
    overflow: hidden;
    .thumb-box {
      @include Position(absolute, $right: 80px, $top: 120px);
      overflow: hidden;
      width: 240px;
      height: 360px;
      border-radius: 12px;
      z-index: 10;
    }
    .thumb-box .no-thumb {
      @include Position(absolute, $left: 0, $right: 0, $top: 0, $bottom: 0);
      display: flex;
      flex-direction: column;
      background-color: #252525;
      justify-content: center;
      align-items: center;
      padding: 0 20px;
      z-index: 10;
    }
    .thumb-box .no-thumb .alt-text {
      @include Ellipsis($multi: true, $line: 2);
      overflow: hidden;
      word-wrap: break-word;
      font-size: 20px;
      color: #fff;
      text-align: center;
      line-height: 29px;
      white-space: inherit;
    }
    &:after {
      @include Position(absolute, $left: 0, $top: 0);
      width: 1240px;
      height: 698px;
      background-color: rgba(27, 27, 27, 0.4);
      content: '';
    }
  }
</style>
